import { CrudState } from "@/store/crud/State";

export class State extends CrudState {
  token = {}; // <-- persisted!
  accessToken: string | null = null; // <-- persisted
  language = "de";
  loginMessage: string | null = null;
}
